import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


const store = new Vuex.Store({
  state: {
    $newList: [],
    $imList: {},
    $userinfo: {},
    $onMsg: true
  },
  mutations: {
    setPageText(state, msg) {
      state.pageText = msg;
    },
  }
});

export default store;